export default __webpack_public_path__ + "static/media/sopimus-darkblue.4e335a36.svg";